import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { ICambioPassword } from '../interfaces/ICambioPassword';
import * as Constants from '../utils/constants'
import { LoginService } from '../services/login.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm: FormGroup

  constructor(private formBuilder: FormBuilder, private alertUtil: AlertUtil, private loginService: LoginService) {
    //build form
    this.changePasswordForm = this.formBuilder.group({
      'oldPassword': ['', Validators.required],
      'newPassword': ['', Validators.required],
      'confirmNewPassword': ['', Validators.required]
    })
  }

  ngOnInit() {
  }

  onSubmit() {
    //retrieve values from form
    let oldPassword = this.changePasswordForm.controls['oldPassword'].value
    let newPassword = this.changePasswordForm.controls['newPassword'].value
    let confirmNewPassword = this.changePasswordForm.controls['confirmNewPassword'].value

    // check if new password and the confirmed one are the same
    if (newPassword == confirmNewPassword) {
      // confirm change password
      this.alertUtil.showConfirmationAlert("LBL_CONFIRM_CHANGE_PASSWORD", null, null, null, null, () => {
        // create bean
        let cambioPassword: ICambioPassword = {
          ApplicationName: "/",
          Username: localStorage.getItem(Constants.LS_USERNAME),
          OldPassword: oldPassword,
          NewPassword: newPassword
        }

        //change password is user confirm
        Loading.isLoading = true
        let reqBuilder = new RequestBuilder(cambioPassword)
        this.loginService.changePassword(reqBuilder).pipe(finalize(() => {
          Loading.isLoading = false
        })).subscribe(
          response => {
            if (response.data) {
              this.alertUtil.showAlert("LBL_PASSWORD_CHANGED")
            }
            else if (response.error) {
              let errorKey = "LBL_ERROR_" + response.error.Code
              this.alertUtil.showErrorAlert(errorKey)
              console.log("ERROR: " + response.error.Stack)
            }
            else {
              this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
            }
          },
          error => {
            let errorKey ="LBL_HTTP_ERROR_0"
            if(error.status){
              errorKey = "LBL_HTTP_ERROR_" + error.status
            }
            this.alertUtil.showErrorAlert(errorKey)
          }
        )
      })
    }
    else {
      this.alertUtil.showErrorAlert("LBL_ERROR_CONFIRM_NEW_PASSWORD")
    }
  }

}
